import { Design, Intent } from 'enums';
import React from 'react';

import { Input } from './styles';

interface IProps extends React.HTMLAttributes<HTMLInputElement> {
  /**
   * The design of the input field
   */
  design?: Design;
  /**
   * Intent to be applied to the input (e.g. Danger when field is invalid)
   */
  intent?: Intent | null;
  value?: string;
}

const TextInput = React.forwardRef(
  ({ design = Design.STANDARD, ...props }: IProps, ref) => {
    return (
      <Input
        design={design}
        {...props}
        ref={ref as React.MutableRefObject<HTMLInputElement | null>}
      />
    );
  },
);

TextInput.defaultProps = {
  design: Design.STANDARD,
  intent: Intent.NONE,
  value: undefined,
};

export default TextInput;
